import {TailwindBreakpointsEnum} from "@/lib/enums/TailwindBreakpointsEnum";

export const getTailwindBreakpoint = (width: number): TailwindBreakpointsEnum => {
    if (width >= 1536) {
        return TailwindBreakpointsEnum.TWO_XL;
    } else if (width >= 1280) {
        return TailwindBreakpointsEnum.XL;
    } else if (width >= 1024) {
        return TailwindBreakpointsEnum.LG;
    } else if (width >= 768) {
        return TailwindBreakpointsEnum.MD;
    } else if (width >= 640) {
        return TailwindBreakpointsEnum.SM;
    } else {
        return TailwindBreakpointsEnum.XS;
    }
}
